var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasStatus)?_c('div',{staticClass:"is-flex is-align-items-center",staticStyle:{"width":"100%"}},[_c('sort-arrows',{attrs:{"margin":"mr-2","list":_vm.manager.list,"sorters":{
      asc: `sort${_vm.typeTitleCase}StatusTypeAscending`,
      desc: `sort${_vm.typeTitleCase}StatusTypeDescending`,
    }}}),_c('table-head-status',{attrs:{"manager":_vm.manager,"type":_vm.type}})],1):_c('span',[_vm._v("Status")])
}
var staticRenderFns = []

export { render, staticRenderFns }